<template>
  <div class="Login">
    <div class="loginHeader">
      <div class="loginHeaderLeft">
        <img src="../assets/Starting/img-login/left.png" />
      </div>
      <div style="display:none" class="loginHeaderRight">
        <span @click="open4">联系我们</span>
      </div>
    </div>
    <div class="loginBody">
      <div class="loginMain">
        <div class="loginMainHeader">
          <span>欢迎登录</span>
        </div>
        <div class="loginMainBody" v-if="foot">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="login-form"
            label-position="left"
            label-width="0px"
          >
            <el-form-item prop="name">
              <i class="iconfont icon-yonghumingdengluye"></i>
              <el-input
                type="text"
                placeholder="用户名"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <i class="iconfont icon-mimadengluye"></i>
              <el-input
                placeholder="密码"
                type="password"
                v-model="ruleForm.password"
              ></el-input>
            </el-form-item>
            <div class="code_div">
              <el-form-item prop="code">
                <img
                  id="icon_list"
                  class="iconfont"
                  src="../assets/login/code.png"
                  alt
                />
                <el-input
                  class="onst_yan"
                  placeholder="验证码"
                  type="text"
                  v-model="ruleForm.code"
                  @keyup.enter.native="submit"
                ></el-input>
              </el-form-item>
              <div class="input_img" @click="code_doing()">
                <img :src="this.codeImg.picture" alt />
              </div>
            </div>
            <div class="code_iphone">
              <span @click="toom()">手机号登录</span>
            </div>
            <el-form-item class="submitBox">
              <el-button
                class="loginBtn"
                @keyup.enter.native="submit"
                @click="submit"
                :loading="logining"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="loginMainBody" v-else>
          <el-form
            :model="ruleIphone"
            :rules="rulesIPhone"
            ref="login-phone"
            label-position="left"
            label-width="0px"
          >
            <el-form-item prop="phone">
              <i class="iconfont icon-yonghumingdengluye"></i>
              <el-input
                type="text"
                placeholder="手机号"
                v-model="ruleIphone.phone"
              ></el-input>
            </el-form-item>
            <div class="code_div">
              <el-form-item prop="phoneVerificationCode">
                <img
                  id="icon_list"
                  class="iconfont"
                  src="../assets/login/code.png"
                  alt
                />
                <el-input
                  class="onst_yans"
                  placeholder="验证码"
                  type="text"
                  v-model="ruleIphone.phoneVerificationCode"
                  @keyup.enter.native="submitPhone()"
                ></el-input>
              </el-form-item>
              <div class="input_img_phone" @click="code_phone()">
                <span>获取验证码</span>
              </div>
            </div>
            <div class="code_iphone">
              <span @click="toom()">账号登录</span>
            </div>
            <el-form-item class="submitBox">
              <el-button
                class="loginBtn"
                type="primary"
                @keyup.enter.native="submitPhone()"
                @click="submitPhone()"
                :loading="logining"
                >登录</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="loginFoot">
      <a href="https://beian.miit.gov.cn" target="_blank">浙ICP备16035809号</a>
      <!-- <span>&copy;2013-2019&nbsp;郎视集团版权所有</span> -->
    </div>
    <el-dialog title="联系我们" :visible.sync="dialogVisible">
      <div class="emailMsg">
        <span>公司邮箱：ls@lsg-tech.com</span>
      </div>
      <div class="phoneMsg">
        <span>公司电话：0571-89733335</span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { CodeInfo, login, CodeIphone } from "../api/user";
export default {
  data() {
    return {
      logining: false,
      dialogVisible: false,
      ruleForm: {
        name: "", //用户名
        password: "", //密码
        code: "", //图片验证码
        uuid: "", //图片验证码id
      },
      ruleIphone: {
        phone: "", //手机号
        phoneVerificationCode: "", //手机验证码
      },
      codeImg: {},
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      rulesIPhone: {
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        phoneVerificationCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      foot: true,
    };
  },
  created() {
    this.code();
  },
  methods: {
    toom() {
      this.foot = !this.foot;
    },
    code() {
      CodeInfo().then((res) => {
        this.codeImg = res.data.data;
        this.ruleForm.uuid = res.data.data.pictureId;
      });
    },
    // 重新调用验证码接口
    code_doing() {
      this.code();
    },
    // 发送手机验证码
    code_phone() {
      CodeIphone({
        phone: this.ruleIphone.phone,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: res.data.message,
            type: "success",
          });
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },

    submit() {
      // this.$router.push({ name: "home" });
      // 表单验证
      this.$refs["login-form"].validate((valid, err) => {
        if (!valid) {
          console.log("登陆失败", valid);
          return;
        }
        //验证通过，请求登陆
        this.handleSubmit();
      });
    },
    handleSubmit() {
      this.logining = true;
      login({
        username: this.ruleForm.name,
        password: this.Rsa.encrypt(this.ruleForm.password),
        code: this.ruleForm.code,
        uuid: this.ruleForm.uuid,
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.logining = false;
            window.sessionStorage.setItem(
              "token",
              JSON.stringify(res.data.data.token)
            );
            // this.$store.commit('tokenMon',res.data.data.token)
            this.$store.commit("nicknameMon", res.data.data.nickname);
            this.$router.push({ name: "home" });
            this.$message({
              message: "登录成功",
              type: "success",
            });
          } else {
            this.logining = false;
            this.code();
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.logining = false;
          this.$message.error("登录失败，手机号或验证码错误");
        });
    },
    submitPhone() {
      // 表单验证
      this.$refs["login-phone"].validate((valid, err) => {
        if (!valid) {
          console.log("登陆失败", valid);
          return;
        }
        //验证通过，请求登陆
        this.testPhone();
      });
    },
    testPhone() {
      this.logining = true;
      login({
        phone: this.ruleIphone.phone,
        phoneVerificationCode: this.ruleIphone.phoneVerificationCode,
      })
        .then((res) => {
          
          if (res.data.code == 200) {
            this.logining = false;
            this.$message({
              message: "登录成功",
              type: "success",
            });
            // this.$store.commit("tokenMon", res.data.data.token);
            // console.log(res.data.data.token);

            window.sessionStorage.setItem(
              "token",
              JSON.stringify(res.data.data.token)
            );
            // this.$store.commit("tokenMon", res.data.data.token);
            this.$store.commit("nicknameMon", res.data.data.nickname);
            this.$router.push({ name: "home" });
          } else {
            this.logining = false;
            this.code_phone();
            this.$message({
              message: res.data.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.logining = false;
          this.$message.error("登录失败，手机号或验证码错误");
        });
    },

    open4() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
.Login {
  .loginBody {
    .loginMain {
      .loginMainBody {
        .el-input {
          margin-top: 14px;
          width: 80%;
          .el-input__inner {
            padding-left: 38px;
            background-color: #fff !important;
            border: 1px solid #dcdfe6 !important;
          }
          .el-input__inner:hover {
            border-color: #ffb54c;
          }
          .el-input__inner:focus {
            border-color: #ffb54c;
          }
        }
        .loginBtn {
          width: 80%;
          margin-top: 36px;
          height: 46px;
          font-size: 18px;
          background-color: #ffa932;
          color: #fff;
          border: 1px solid #ffa932;
        }
        .loginBtn:hover {
          border-color: #ffb54c;
          background-color: #ffb54c;
        }
        .loginBtn:focus {
          border-color: #ffa932;
        }
        .el-form-item__error {
          padding-left: 10%;
        }
      }
    }
  }
  .el-dialog__wrapper {
    .el-dialog {
      margin-top: 0 !important;
      width: 455px;
      top: calc(50% - 136px) !important;
      /*border-radius: 5px;*/
      .el-dialog__header {
        background-color: #0d8aca;
        height: 27px;
        font-size: 20px;
        padding: 12px;
        .el-dialog__title {
          color: #fff;
        }
        .el-dialog__headerbtn {
          .el-dialog__close {
            color: #fff;
          }
        }
      }
      .el-dialog__body {
        padding: 50px 12px;
        div {
          text-align: center;
          border: 1px solid #eeeeee;
          color: #1f1f1f;
          font-size: 18px;
          height: 46px;
          line-height: 46px;
        }
        .phoneMsg {
          margin-top: 26px;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.Login {
  .loginHeader {
    height: 79px;
    background-color: #041738;
    border-bottom: 1px solid #364660;
    .loginHeaderLeft {
      line-height: 94px;
      margin-left: 43px;
      float: left;
      img {
        height: 30px;
      }
    }
    .loginHeaderRight {
      float: right;
      line-height: 79px;
      margin-right: 55px;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
    }
  }
  .loginBody {
    position: absolute;
    left: 0;
    top: 80px;
    width: 100%;
    height: calc(100% - 80px);
    background-image: url("../assets/Starting/img-login/login.png");
    background-repeat: no-repeat;
    background-size: cover;
    .loginMain {
      width: 485px;
      // height: 484px;
      background-image: url("../assets/Starting/img-login/loginMain.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: absolute;
      top: 18%;
      right: 15%;
      padding-bottom: 15px;
      .loginMainHeader {
        line-height: 85px;
        width: 100%;
        text-align: center;
        span {
          font-size: 24px;
          color: #fff;
        }
      }
      .loginMainBody {
        padding-top: 36px;
        text-align: center;
        .iconfont {
          color: #999999;
          position: absolute;
          left: calc(10% + 10px);
          z-index: 1;
          font-size: 18px;
          top: 16px;
        }
      }
    }
  }
  .loginFoot {
    position: absolute;
    height: 35px;
    bottom: 0px;
    color: #7e8c8d;
    text-align: center;
    width: 100%;
    font-size: 16px;
    & * {
      margin: 0 8px;
    }
    a {
      color: #7e8c8d;
    }
    & a:hover {
      color: #eee;
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
.code_div {
  width: 89%;
  height: 10%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  .input_img {
    position: relative;
    left: -10%;
    cursor: pointer;
  }
  .input_img_phone {
    position: relative;
    left: -5%;
    cursor: pointer;
    text-align: center;
    background: #dddddd;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 14px;
    line-height: 40px;
    width: 30%;
    height: 40px;
    top: -4px;

    color: #333333;
  }
  #icon_list {
    top: 28px !important;
  }
  .onst_yan {
    width: 100% !important;
    position: relative;
    left: 10%;
  }
  .onst_yans {
    width: 110% !important;
    position: relative;
    left: 10%;
  }
}
.code_iphone {
  width: 100%;
  font-family: Microsoft YaHei UI;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  color: #1890ff;
  cursor: pointer;
  span {
    position: relative;
    left: -32%;
  }
}
</style>
